
if(process.env.NODE_ENV==="production")
{
module.exports = require("./configureSrore.prod");
}
else
{
module.exports = require("./configureStore.dev");

}